import { Component, OnInit, Input } from '@angular/core';
import { Product, Price } from '@models/product';
import { environment } from '@environments/environment';
import { RouteService } from '@services/route.service';
import { CartService } from '@services/cart.service';
import { GetPricesPipe } from '@pipes/price.pipe';
import { TrackingService } from 'src/app/services/tracking.service';
import { ProductService } from 'src/app/services/product.service';

@Component({
  selector: 'gob-product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.css']
})
export class ProductCardComponent implements OnInit {
  @Input()
  product: Product;
  loading: boolean=false;
  indImg: number=0;
  isAlertOpen: boolean = false; // AJOUT : Gestion de l'état de la modale d'alerte

  constructor(
    public route: RouteService,
    private cart: CartService,
    private gPrice: GetPricesPipe,
    private tracking: TrackingService,
    private pService: ProductService) {

    }

  ngOnInit(): void {
  }

  getImage(ind: number){
    // There is a cover
    if (this.product.cover) {
      return `${environment.imgUrl}/product/${this.product.cover}`;
    }

    // There is a main image
    if (this.product.mainImage != null) {
      return `${environment.imgUrl}/product/${this.product.mainImage.name}`;
    } else {
      return `assets/img/logo/logo.png`;
    }

  }

  getQueryParam(price: Price){
    if(this.product.cover)
      return {price: price.ident};
    else
      return {};
  }

  addCart(product: Product){
    this.loading=true;
    this.cart.add(product, this.gPrice.transform(product, 0), 1, () => this.loading=false);

    // Facebook Pixel custom event
    this.tracking.trackMeta('AddToCart', {
      content_ids: [this.product.ref],
      content_name: this.product.name,
      content_type: 'product',
      value: this.gPrice.transform(product, 0),
      currency: 'EUR'
    });

    // Google Ads
    this.tracking.trackAddToCart(
      Number(this.gPrice.transform(product, 0))
    );
  }

/**
 * Checks if a product can be ordered or not.
 * @param product The product to check.
 * @returns true if the product can be ordered, false otherwise.
 * @see CartService.canOrder
 */
  canOrder(product: Product){
    return this.cart.canOrder(product);
  }

/**
 * Determines if a product is available for online ordering only.
 * @param product The product to check.
 * @returns true if the product is not in rupture state and has no order limit, indicating that it is available for online ordering only; false otherwise.
 */
  orderOnlineOnly(product: Product){
    return this.cart.orderOnlineOnly(product);
  }

  /**
   * Returns the background color based on the given tab.
   * @param tab Tab to return the background color for.
   * @returns The background color as a string.
   */
  getColor(tab: string): string {
    switch (tab) {
      case 'news':
        return 'var(--color-green-light)';
      case 'promos':
        return 'var(--color-orange)';
      case 'coeur':
        return 'var(--color-red)';
      case 'goldngob':
        return 'var(--color-golden)';
      default:
        return 'var(--color-green)';
    }
  }

  /**
   * Returns the style for a given tab based on the window width.
   * If the window width is greater than 667, the style for the desktop is returned.
   * Otherwise, the style for mobile is returned.
   * @param tab Tab to return the style for.
   * @returns The style for the given tab as an object.
   */
  getStyle(tab: string){
    let style: any={
      backgroundColor: this.getColor(tab),
    }

    let styleMobile: any={
      backgroundColor: this.getColor(tab),
    }

    if(window.innerWidth>667)
      return style;
    else
      return styleMobile
  }

  /**
   * Sets an alert for the given product with the given email address.
   * This will send an email to the given email address when the product is back in stock.
   * @param product The product to set the alert for.
   * @param email The email address to send the alert to. Defaults to 'aurelie@gobcorp.fr'.
   */
  alert(product: Product, email: string = 'aurelie@gobcorp.fr'){
    this.pService.setAlert(product.ident, email)
      .subscribe((response: any) => {
            console.log(response);
      });
  }

  /**
   * AJOUT : Ouvre la modale d'alerte pour le produit actuel
   */
  openAlertModal() {
    this.isAlertOpen = true;
  }
}